module.exports = __webpack_public_path__ + "img/PriceIcon.5a0a5149.svg";